import { useController } from "react-hook-form";
import { useState, useRef, useEffect } from "react";
import { FilterButton } from "./FilterButton";
import { FilterMenu } from "./FilterMenu";

const MultiSelectDropdown = ({
  options = [],
  control,
  name,
  label,
  icon,
  isGrouped = false,
}) => {
  const { field } = useController({ name, control });
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const getSelectedLabels = () => {
    if (field.value.length === 0) {
      return label;
    }

    let selectedLabels;
    if (isGrouped) {
      selectedLabels = field.value.map((value) => {
        for (let group of options) {
          const option = group.options.find((opt) => opt.value === value);
          if (option) return option.label;
        }
        return value;
      });
    } else {
      selectedLabels = field.value.map(
        (value) =>
          options.find((option) => option.value === value)?.label || value
      );
    }

    const firstLabel = selectedLabels[0];
    const additionalCount = selectedLabels.length - 1;

    return additionalCount > 0
      ? `${label}: ${firstLabel}, +${additionalCount} more`
      : `${label}: ${firstLabel}`;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <FilterButton
        toggleDropdown={toggleDropdown}
        label={getSelectedLabels()}
        icon={icon}
      />

      {isOpen && (
        <FilterMenu
          options={options}
          field={field}
          control={control}
          isGrouped={isGrouped}
        />
      )}
    </div>
  );
};

export default MultiSelectDropdown;
